<template>
    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="status"
        />

        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="entities"
            :item-class="itemRowBackground"
            :options.sync="options"
            :server-items-length="total"
            :items-per-page="10"
            :footer-props="{ itemsPerPageOptions:[10, 20, 30] }"
            :page.sync="options.page"
            @page-count="paginationPageCount = $event"
            class="elevation-1 customization-list-table pagination-list-table sticky-table"
            @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.id, type: 'None.Reception' })"
        >
        <!--@dblclick:row="(event, data) => $router.push({ name: 'Meeting', params: { id: data.item.id } })"-->
            <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

            <template v-slot:[`item.event_date`]="{ item }">
                <div>
                    {{ dateFormat(item.event_date, 'DD.MM.YYYY') }}
                    <!-- &nbsp;&nbsp;&nbsp;{{ $moment(item.begin_time, 'HH:mm:ss').format('HH:mm') }} - {{ $moment(item.end_time, 'HH:mm:ss').format('HH:mm') }} -->
                </div>
            </template>
            
            <template v-slot:[`item.subject`]="{ item }">
                <div class="elipsis-text-wrap">
                    <!-- <v-doc-type-chip type='Meeting' :text="$t('Совещание')" />                         -->
                    <div class="etw-text-container">
                        <div class="etw-text" v-tooltip.top-center="item.subject">
                            {{ item.subject }}
                            <template v-if="item.status==2"> 
                                <span> - {{ item.recipient }}</span>
                            </template>
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:[`item.status`]="{ item }">
                 <StatusChip :status="avaibleStatuses[$options.indexToNameStatus[item.status]]"/>
                 <!-- <div>
                    {{ item.status }}
                 </div> -->
            </template>

            <template v-slot:[`footer.prepend`]>
                <v-pagination
                    v-model="options.page"
                    :length="paginationPageCount"
                    :total-visible="$listPaginationTotal"
                    color="teal"
                ></v-pagination>
            </template>

        </v-data-table>

    </div>
</template>

<script>
import i18n from '@/i18n';
import { httpAPI } from "@/api/httpAPI";
import Axios from 'axios';
import _ from 'lodash';
import sys from '@/services/system';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';
import StatusChip from '@/components/global/chips/StatusChip';
import Toolbar from '@/components/documents/Toolbar.vue';

export default {
    name: "ReceptionList",
    indexToNameStatus: [
        "event_free",
        "event_reserved",
        "event_planned"
    ],
    components: {
        SearchPanel,
        StatusChip,
        FilterPanel,
        Toolbar
    },
    columnIndex:  {
        id: 1,
		event_date: 2,
		begin_time: 3,
		end_time: 4,
		subject: 5,
		status: 6,
		recipient: 7
    },
    computed: {
        search: {
            get: function() {
                return this.$store.getters['qalaQyzmet/receptionSchedule/list/getSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('qalaQyzmet/receptionSchedule/list/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('qalaQyzmet/receptionSchedule/list/SET_SEARCH', v);
            }, 500)
        },
        status: {
            get: function() {
                return this.$store.getters['qalaQyzmet/receptionSchedule/list/getStatus'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('qalaQyzmet/receptionSchedule/list/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('qalaQyzmet/receptionSchedule/list/SET_STATUS', v);
            }, 500)
        },
        headers: {
            get: function() {
                let items = [
                    // { text: i18n.t("№"), value: 'number', width: '70px' },
                    { text: i18n.t("Дата_приема"), value: 'event_date', width: '80px' },
                    { text: i18n.t("Прием"), value: 'subject' },
                    // { text: i18n.t("Место"), value: 'place', width: '35%'},
                    // { text: i18n.t("Председатель"), value: 'initiatorname', width: '200px'},
                    // { text: i18n.t("Секретарь"), value: 'secretaryname', width: '200px'},
                ];
                if (this.status === 'AllReceptions')
                    items.push({ text: i18n.t("Статус"), value: 'status', width: '150px', sortable: false, class: 'status-col'});
                return items;
            }
        },
        options: {
            get: function() {
                return this.$store.getters['qalaQyzmet/receptionSchedule/list/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('qalaQyzmet/receptionSchedule/list/SET_TABLE_OPTION', newValue);
            }
        },
        filter () {
            return {
                ...this.options,
                Type: this.status,
                SearchStr: this.search
            }
        },
        avaibleStatuses() {
            //Workstatuses
            // 1 - Запланированно
            // 2 - Выполняется
            // 3 - Завершено
            // 0 - Ошибка расчета статуса
            return this.$store.getters['qalaQyzmet/receptionSchedule/GetAvaibleStatuses'];
        },
    },
    data: () => {
        return {
            loading: true,
            cancellationTokenSorce: null,
            total: 0,            
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
            filterDataSource: null
        }
    },
    methods: {
        resetPage() {
            this.$store.commit('qalaQyzmet/receptionSchedule/list/SET_TABLE_OPTION_PAGE', 1);
        },
        itemRowBackground (item) {
            return item.readed ? '' : 'font-weight-bold';
        },
        onToolbarClick(event, btn){
            this[btn.Action](btn);
        },
        async Refresh() {
            await this.getData(true);
        },
        async Export(){
            let filter = JSON.parse(this.prevTableFilterObject);
            delete filter.Limit;
            delete filter.Offset;
            let exportURI = `api/csc/receptionlistexport?param=${JSON.stringify(filter)}&mode=${process.env.NODE_ENV}`;
            exportURI += `&token=${this.$store.getters['global/auth/getUserInfo']?.Token}`;
            
            let text = i18n.t('Экспорт_списка_приема_на_formatedDateTime.message', { formatedDateTime: this.$moment().format('DD.MM.YYYY HH.mm.ss') });

            this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'Xls' });
        },
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;

            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;

            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();
            
            await this.loadFilters();

            let response = await httpAPI({
                url: `/api/csc/receptionlist?filter=${this.getTableFilterObject()}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;

            this.loading = false;
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, Type, SearchStr } = this.filter;
            
            console.log('getTableFilterObject', sortBy, sortDesc);

            let OrderDir = sortDesc;
            
            let OrderBy = sortBy.reduce((acc, item) => {
                    
                if (item === 'subject')
                        acc.push(3); // begin_time
                    else
                        acc.push(this.$options.columnIndex[item]);

                    return acc;
                }, []);

            return JSON.stringify({ SearchStr, Type, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
        async loadFilters() {
            let filterResponse = await httpAPI({
                url: `api/csc/receptionfilter`,
                method: 'GET',
            });

            this.filterDataSource = filterResponse ? filterResponse.data.Payload : null;
        },
        dateFormat: sys.dateFormat,
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        }
    },
    async created() {
        let menu = [
            {
                "Action": "Export",
                "Icon": "doc_send",
                "Items": null,
                "Text": "Экспорт_списка",
                "ToolTip": "Экспорт_списка_совещаний",
                "Type": "Documents",
                Localize: true
            },
            {
                "Action": "Refresh",
                "Icon": "refresh",
                "Items": null,
                "Text": "Обновить",
                "ToolTip": "Обновить_форму",
                "Type": null,
                Localize: true
            }
        ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu });
    },
}
</script>